import React from 'react';
export function UrgencyBar() {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-urgency text-white py-3 px-4 text-center shadow-md" data-id="element-115">
      <p className="font-sans font-bold text-sm md:text-base tracking-wide flex items-center justify-center gap-2" data-id="element-116">
        <span className="animate-pulse-fast text-lg md:text-xl" data-id="element-117">⚠️</span>
        OFFRE DE LANCEMENT : RÉDUCTION DE 85% DISPONIBLE POUR LES 100 PROCHAINS
        CLIENTS
      </p>
    </div>;
}